export type Status = "queued" | "success" | "fail" | "in progress" | "waiting for invite acceptance";
export interface AuditRequest {
  requestId: string;
  store: string;
  market: string;
  account: string;
  status: Status;
  requestedDate: string;
  completedDate: string;
  chargebackMonths: number;
  shortageMonths: number;
  accuralMonths: number;
  poMonths: number;
  errorMessage: string | null;
}

export enum AuditRequestStatusNumber {
  Queued = 0,
  Success = 1,
  Fail = 2,
  InProgress = 3,
  WaitingForInviteAcceptance = 4,
}
